import React from 'react';
import { Tooltip } from 'reactstrap';

//nothing specific to handle in generic component as of now. Need to handle if anything.
export default class Text extends React.Component {
    constructor(props) {
        super(props);
        this.toggleToolTip = this.toggleToolTip.bind(this);
        this.validateOnBlur = this.validateOnBlur.bind(this);
        this.state = {
            tooltipOpen: false,
            invalidInput: false
        };
    }

    componentDidUpdate() {
        if (this.props.focusBlankField && this.refs.actualTextArea)
            this.refs.actualTextArea.focus();
    }

    toggleToolTip() {
        this.setState({
            tooltipOpen: !this.state.tooltipOpen
        });
    }

    onChange(event) {
        this.props.onChange(event, event.target.value);
    }

    validateOnBlur(event) {
        if (this.props.required) {
            if (event) {
                event.persist();
            }
            let sValue = event && event.target ? event.target.value : this.refs.actualTextArea.value;
            if (sValue) {
                this.setState({ invalidInput: false });
            }
            else {
                this.setState({ invalidInput: true });
            }
        }
    }

    render() {

        const { name, id, autoFocus, disabled, placeholder, value, maxSize, required, rows, cols, type, className,
            inputErrorMsg, tooltipID, tooltipMsg, showAsInvalid, containerClass } = this.props;
        var dynamicClass = className ? className : '';
        const containerClassName = (containerClass ? " " + containerClass : "") + (value ? " input-not-empty" : "") + (showAsInvalid || this.state.invalidInput ? " input-invalid" : "") + ((tooltipID && tooltipMsg) ? " input-append" : "");

        return (
            <div className={"il-group" + containerClassName}>
                <textarea type={type}
                    className={"form-control " + dynamicClass}
                    value={value}
                    required={required}
                    name={name}
                    id={id}
                    disabled={disabled}
                    autoFocus={autoFocus}
                    placeholder={placeholder ? placeholder : ""}
                    aria-label={placeholder ? placeholder : ""}
                    maxLength={maxSize ? maxSize : ""}
                    rows={rows ? rows : "4"}
                    cols={cols ? cols : ""}
                    title={placeholder ? "Please fill out the " + placeholder : "Please fill out this field."}
                    ref="actualTextArea"
                    onChange={e => this.onChange(e)}
                    onBlur={this.validateOnBlur}
                    onKeyUp={this.validateOnBlur}
                />
                {(tooltipID && tooltipMsg) && <div className="input-icon-append ">
                    <span className="icon-info" id={tooltipID} />
                    <Tooltip placement="top" isOpen={this.state.tooltipOpen} autohide={false} target={tooltipID} toggle={this.toggleToolTip}>
                        {tooltipMsg}
                    </Tooltip>
                </div>}
                <div className="il-label" aria-hidden="true">{placeholder}</div>
                {inputErrorMsg && <div className="input-error-msg">{inputErrorMsg}</div>}
            </div>);
    }
}
